import request from "../../utils/request";

export function getVipRechargeList(params) {
  return request("/vipRecharge/getList", {
    method: "get",
    params
  });
}

export function getVipRechargeCount(params) {
  return request("/vipRecharge/getCount", {
    method: "get",
    params
  });
}

export function addVipRecharge(params) {
  return request("/vipRecharge/add", {
    method: "post",
    params
  });
}

export function searchVip(params) {
  return request("/vipRecharge/searchVip", {
    method: "get",
    params
  });
}

export function getVipRechargeCost(params) {
  return request("/vipRecharge/getCost", {
    method: "get",
    params
  });
}
